import React from 'react';
import './../../PAT.css'

function AdminDashboardMenu(props) {
    const normalMenuStyle = {
        color: 'black',
    }
    const selectedMenuStyle = {
        color: 'white',
    }

    return (
        <div className="AdminSideMenu mt-5">
            {
                props.menuList.map((item, index) => {
                    return (
                        item.active ?
                            <a 
                                className={props.menuName === item.name ? "AdminSideMenuTextSelected" : "AdminSideMenuText"}
                                onClick={props.onClick} 
                                id={item.name} 
                                key={index}
                            >
                                {item.name.split('-').join(' ')}
                            </a>
                        :
                            null
                    );
                })
            }
        </div>
    );
}

export default AdminDashboardMenu;
